import { Component, effect, inject, signal } from '@angular/core';
import { UserService } from '@services/user.service';
import { EpxAvatarComponent } from '@shared/components/misc/epx-avatar-component/epx-avatar.component';

@Component({
    selector: 'app-user-avatar',
    imports: [EpxAvatarComponent],
    template: ' <epx-avatar-component [name]="this.userName()"></epx-avatar-component> '
})
export class UserAvatarComponent {
    userService = inject(UserService);
    user = this.userService.user;
    userName = signal<string>('');

    constructor() {
        effect(() => {
            let fullName = `${this.user().firstname} ${this.user().lastname}`;
            console.log(fullName);
            this.userName.set(fullName);
        });
    }
}
